/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Csv_Deep_P2Inputs */

const en_to_csv_deep_p2 = /** @type {(inputs: To_Csv_Deep_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Two deliberate deviations from RFC 4180 are worth knowing before you hand the file to someone. First, records are separated with a single line feed rather than the carriage return and line feed pair the specification requires. Nearly every tool accepts line feeds, but a strict RFC 4180 parser is entitled to complain. Second, no byte order mark is written. Excel on Windows reads a UTF-8 CSV without a byte order mark using the system code page, which turns non ASCII names into mojibake.`)
};

const ko_to_csv_deep_p2 = /** @type {(inputs: To_Csv_Deep_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`파일을 누군가에게 건네기 전에 알아둘 만한, 의도적인 RFC 4180 이탈이 두 가지 있습니다. 첫째, 레코드는 규격이 요구하는 캐리지 리턴과 라인 피드 쌍이 아니라 라인 피드 하나로 구분됩니다. 거의 모든 도구가 라인 피드를 받아들이지만, 엄격한 RFC 4180 파서라면 문제를 제기할 권리가 있습니다. 둘째, 바이트 순서 표시가 기록되지 않습니다. Windows의 Excel은 바이트 순서 표시가 없는 UTF-8 CSV를 시스템 코드 페이지로 읽으며, 비ASCII 이름이 깨진 글자가 됩니다.`)
};

const ja_to_csv_deep_p2 = /** @type {(inputs: To_Csv_Deep_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイルを誰かに渡す前に知っておく価値のある、意図的な RFC 4180 からの逸脱が 2 つあります。1 つ目、レコードは規格が要求するキャリッジリターンとラインフィードの対ではなく、ラインフィード 1 つで区切られます。ほぼすべてのツールがラインフィードを受け入れますが、厳格な RFC 4180 パーサには文句を言う権利があります。2 つ目、バイトオーダーマークが書かれません。Windows の Excel はバイトオーダーマークのない UTF-8 CSV をシステムコードページで読むため、非 ASCII の名前が文字化けします。`)
};

/**
* | output |
* | --- |
* | "Two deliberate deviations from RFC 4180 are worth knowing before you hand the file to someone. First, records are separated with a single line feed rather th..." |
*
* @param {To_Csv_Deep_P2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_csv_deep_p2 = /** @type {((inputs?: To_Csv_Deep_P2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Csv_Deep_P2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_csv_deep_p2(inputs)
	if (locale === "ko") return ko_to_csv_deep_p2(inputs)
	return ja_to_csv_deep_p2(inputs)
});